import React, { useState } from 'react';
import { ReactComponent as SearchIcon } from './../../../assets/icons/search.svg';
import { Button } from './button';
import styles from './search.module.css';

export const SearchInput = ({
    onSearch,
    isLight = false,
    defaultValue = null,
    disabled = false,
    ...props
}) => {
    const [value, setValue] = useState(defaultValue ?? '');

    const keyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            search(e);
        }
    };

    const search = (e, explicit = false) => {
        if (onSearch) onSearch(value, e, explicit);
    };

    return (
        <div className={styles.Search + (isLight ? ' ' + styles.Light : '')}>
            <input
                type='search'
                {...props}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                onKeyDown={keyDown}
                disabled={disabled}
            />
            <Button
                type='button'
                title='Search'
                onClick={(e) => search(e, true)}
                rippleColor={isLight ? 'rgba(255, 255, 255, 0.1)' : undefined}
                disable={disabled}
            >
                <div className={'icon' + (isLight ? ' text-color' : '')}>
                    <SearchIcon />
                </div>
            </Button>
        </div>
    );
};
